<template>
  <div>
    <h1 class="view-title mb-12 text-center">{{ params.title }}</h1>

    <div class="text-center mb-16" v-if="params.lead" v-html="params.lead"></div>

    <iframe src="/static/audio/250-milliseconds-of-silence.mp3" allow="autoplay" id="audio" style="display: none"></iframe>

    <v-row v-for="(chapter, i) in params.chapters" :key="i" class="my-4">
      <v-col v-if="chapter.img" :cols="4">
        <div class="pa-5 text-center">
          <img v-lazy="chapter.img.src" class="oval-frame mb-6">
          <small v-if="chapter.img.title">{{ chapter.img.title }}</small>
        </div>
      </v-col>
      <v-col :cols="chapter.img ? 8 : 12" class="d-flex align-center" fill-height>
        <component v-if="chapter.content" :is="{ template: chapter.content }"></component>
      </v-col>
    </v-row>

    <v-row v-if="params.img || params.content">
      <v-col v-if="params.img" :cols="4">
        <div class="pa-5 text-center">
          <img :src="params.img.src" class="oval-frame mb-6">
          <small v-if="params.img.title">{{ params.img.title }}</small>
        </div>
      </v-col>
      <v-col :cols="params.img ? 8 : 12" class="d-flex align-center" fill-height>
        <component v-if="params.content" :is="{ template: params.content }"></component>
      </v-col>
    </v-row>

    <portal to="main">
      <CoolLightBox
        :items="params.items"
        :index="index"
        :slideshow="false"
        :useZoomBar="true"
        thumbsPosition="bottom"
        @close="closeEventHandler"
      />
    </portal>


    <v-row class="d-flex flex-wrap justify-center">
      <v-col v-for="(item, i) in params.items" :key="i" cols="3">
        <v-card @click="index = i">
          <v-img
            :src="item.thumb"
            class="white--text align-end"
            height="320px"
          >
            <v-overlay v-if="['mp4'].includes(item.src.slice(-3))" absolute opacity="0.15">
              <v-icon size="128">mdi-play-circle-outline</v-icon>
            </v-overlay>
          </v-img>
          <v-card-title v-if="item.title" v-text="item.title"></v-card-title>
          <v-card-text v-if="item.description" v-text="item.description"></v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  props: ['params'],
  data: () => ({
    index: null
  }),
  mounted() {
    if (this.params.items.length === 1) {
      setTimeout(() => {
        this.index = 0;
      }, 500);
    }
  },
  methods: {
    closeEventHandler() {
      this.index = null;
      if (this.params.items.length === 1) {
        history.go(-1);
      }
    },
  }
};
</script>

<style lang="scss" scoped>
.preview {
  max-width: 60vw;
  height: auto;
}
</style>
